<div class="transcript-content">
  @if (transcript()) {
    @for (entry of transcript()?.entries; track entry) {
      <glxy-transcript-entry [entry]="entry" (contentClicked)="clickedContent($event)"></glxy-transcript-entry>
    }
  } @else {
    <glxy-transcript-entry-loading-state *ngFor="let item of [1, 2, 3]"></glxy-transcript-entry-loading-state>
  }
</div>
